import request from '@/api/request'

const Api = {
  list: '/api/v2/admin/sale/biz/list',
  add: '/api/v2/admin/sale/biz/create',
  update: '/api/v2/admin/sale/biz/update',
  items: '/api/v2/admin/sale/filter/goods',
  allGoods: '/api/v2/admin/sale/list/goods',
  status: '/api/v2/admin/sale/biz/status/edit',
  signStatistic: '/api/v2/merchant/store/activity/sign-in/statistic',
  signCycles: '/api/v2/merchant/store/activity/sign-in/cycles',
  signInCustomerGroupPairs: '/api/v2/merchant/store/activity/sign-in/customer-group/pairs',
  delete: '/api/v2/admin/sale/biz/delete',
  addUpGroupList: '/api/v2/merchant/activity/accumulated-recharge/customer-group/pairs',
  lotteryGroupList: '/api/v2/merchant/store/activity/lottery/customer-group/pairs',
  lotteryOverChance: '/api/v2/merchant/store/activity/lottery/details/for-one-player'
}

// 活动列表
export const getActivityList = (params: any) => {
  return request.get(Api.list, { params })
}

// 新建活动
export const addActivity = (data: any) => {
  return request.post(Api.add, data)
}

// 更新活动
export const updateActivity = (data: any) => {
  return request.post(Api.update, data)
}

// 更新活动状态
export const updateActivityStatus = (data: any) => {
  return request.post(Api.status, data)
}

export const querySignStatistic = (params: any) => {
  return request.get(Api.signStatistic, { params })
}

export const queryRechargeStatistic = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/continuous-recharge/statistic', { params })
}

// 虚拟物品列表-查询
export const getActivityItems = (params: any) => {
  return request.get(Api.items, { params })
}

export const queryLotteryStatistic = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/lottery/statistic', { params })
}

export const queryLotteryDetail = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/lottery/result-list', { params })
}

export const exportLotteryDetail = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/lottery/result-export', { responseType: 'blob', params })
}

export const getFullDiscountStatistic = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/full-discount/statistic-list', { params })
}

export const exportFullDiscount = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/full-discount/statistic-export', { responseType: 'blob', params })
}

export const getFullDiscountOptions = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/full-discount/level-list', { params })
}

export const createCoupon = (data: any) => {
  return request.post('/api/v2/merchant/store/activity/coupons/create', data)
}

export const updateCoupon = (data: any) => {
  return request.post('/api/v2/merchant/store/activity/coupons/update', data)
}

export const getCouponList = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/coupons/list', { params })
}

export const disabledCoupon = (data: any) => {
  return request.post('/api/v2/merchant/store/activity/coupons/invalid', data)
}

export const deleteCoupon = (data: any) => {
  return request.post('/api/v2/merchant/store/activity/coupons/delete', data)
}

export const exportCouponReplay = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/coupons/statistic-export', { responseType: 'blob', params })
}

export const detailCoupon = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/coupons/detail', { params })
}

export const getCouponStatic = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/coupons/statistic', { params })
}

export const getSignCycles = (params: any) => {
  return request.get(Api.signCycles, { params })
}

export const getSignInCustomerGroupPairs = (params: { activity_id: number }) => {
  return request.get(Api.signInCustomerGroupPairs, { params })
}

export const getAddUpReplayList = (params: any) => {
  return request.get('/api/v2/admin/sale/biz/add-credit/statistic', { params })
}

export const getAddUpCycleList = (params: any) => {
    return request.get('/api/v2/merchant/activity/accumulated-recharge/cycles', { params })
}

export const getAddUpResultList = (params: any)=> {
  return request.get('/api/v2/admin/sale/biz/add-credit/result/list', { params })
}

export const exportAddUpResult = (params: any) => {
  return request.get('/api/v2/admin/sale/biz/add-credit/result/export', { responseType: 'blob', params })
}

export const getConsecutiveResult = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/continuous-recharge/result/list', { params })
}

export const exportConsecutiveResult = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/continuous-recharge/result/export', { responseType: 'blob', params })
}
// 连续充值 - 轮次列表
export const getConsecutiveCycleList = (params: any) => {
  return request.get('/api/v2/merchant/activity/continuous-recharge/cycles', { params })
}

export const getAllGoods = (params: any) => {
  return request.get(Api.allGoods, { params })
}

// 顺序解锁 - 回放统计
export const queryQuenUnlockStatistic = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/rolling-offer/statistics', { params })
}

// 顺序解锁 - 结果列表（查看详情）
export const getQuenUnlockResultList = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/rolling-offer/record/list', { params })
}

// 顺序解锁 - 结果导出
export const exportQuenUnlockResult = (params: any) => {
  return request.get('/api/v2/merchant/store/activity/rolling-offer/record/export', { responseType: 'blob', params })
}


export const deleteActivity = (data: any) => {
  return request.post(Api.delete, data)
}

export const getAddUpGroupList = (params: any) => {
  return request.get(Api.addUpGroupList, { params })
}

export const getLotteryGroupList = (params: any) => {
  return request.get(Api.lotteryGroupList, { params })
}

export const getLotteryOverChance = (params: any) => {
  return request.get(Api.lotteryOverChance, { params })
}

// ============ 活动链 API ============

const ActivityChainApi = {
  list: '/api/v2/admin/sale/activity-chain/list',
  create: '/api/v2/admin/sale/activity-chain/create',
  update: '/api/v2/admin/sale/activity-chain/update',
  delete: '/api/v2/admin/sale/activity-chain/delete',
  detail: '/api/v2/admin/sale/activity-chain/detail',
  availableActivities: '/api/v2/admin/sale/activity-chain/available-activities',
}

// 活动链列表
export const getActivityChainList = (params: any) => {
  return request.get(ActivityChainApi.list, { params })
}

// 创建活动链
export const createActivityChain = (data: any) => {
  return request.post(ActivityChainApi.create, data)
}

// 编辑活动链
export const updateActivityChain = (data: any) => {
  return request.post(ActivityChainApi.update, data)
}

// 删除活动链
export const deleteActivityChain = (data: any) => {
  return request.post(ActivityChainApi.delete, data)
}

// 活动链详情
export const getActivityChainDetail = (params: any) => {
  return request.get(ActivityChainApi.detail, { params })
}

// 可加入链的活动列表
export const getAvailableActivities = (params: any) => {
  return request.get(ActivityChainApi.availableActivities, { params })
}
